import React, { useState } from 'react';
import VariantButton from '../VariantButton';
import './index.css';

function VariantSection({ groupedVariants, handleSelected, currentlySelectedVariant }) {
  const [selectedSize, setSelectedSize] = useState(null);

  // Create a new grouping by size instead of by option
  const sizeGroupedVariants = {};
  Object.keys(groupedVariants).forEach(option => {
    groupedVariants[option].forEach(({ size, variant }) => {
      if (!sizeGroupedVariants[size]) {
        sizeGroupedVariants[size] = [];
      }
      sizeGroupedVariants[size].push({ option, variant });
    });
  });
  
  
  // Initialize selectedSize based on currentlySelectedVariant
  React.useEffect(() => {
    if (currentlySelectedVariant) {
      // Find which size this variant belongs to
      Object.keys(sizeGroupedVariants).forEach(size => {
        const hasVariant = sizeGroupedVariants[size].some(({ variant }) => variant.id === currentlySelectedVariant);
        if (hasVariant) {
          setSelectedSize(size);
        }
      });
    }
  }, [currentlySelectedVariant]);

  function renderSizeVariants() {
    return Object.keys(sizeGroupedVariants).map((size) => {
      return (
        <div 
          key={size} 
          onClick={() => {
            setSelectedSize(size);
            handleSelected(null);
          }}
          className={selectedSize === size ? 'variants-size-container-selected' : 'variants-size-container'}
        >
          <span className="variants-size-text">{size}</span>
        </div>
      );
    });
  }

  function renderOptionVariants() {
    if (!selectedSize) {
      return <div></div>;
    } else {
      return sizeGroupedVariants[selectedSize].map(({ option, variant }) => {
        // Check if this is a color variant (contains color information in parentheses)
        const isColorVariant = option.includes(' (');
        
        const isSelected = variant.id === currentlySelectedVariant;
        
        if (isColorVariant) {
          return (
            <div
              style={{ backgroundColor: (option.split('(')[1]).slice(0, -1) }}
              className={`variants-color-dot ${isSelected ? 'variants-color-dot-selected' : ''}`}
              onClick={() => handleSizeAndOptionSelect(variant.id)}
              key={`${selectedSize}-${option}`}
            ></div>
          );
        } else {
          // This is a customization variant
          return (
            <div
              className={`variants-customization-option ${isSelected ? 'variants-customization-option-selected' : ''}`}
              onClick={() => handleSizeAndOptionSelect(variant.id)}
              key={`${selectedSize}-${option}`}
            >
              {option}
            </div>
          );
        }
      });
    }
  }

  function handleSizeAndOptionSelect(id) {
    handleSelected(id);
  }

  // Determine the header text based on the first option type
  const firstOption = Object.keys(groupedVariants)[0];
  const isColorVariant = firstOption && firstOption.includes(' (');
  const optionHeader = isColorVariant ? 'Select Color' : 'Select Customization';

  return (
    <div className="variants-section">
      <div className="variants-size-section">
        <div className="variants-size-header">Select Size</div>
        <div className="variants-sizes">{renderSizeVariants()}</div>
      </div>
      <div className="variants-color-section">
        <div className="variants-color-header">
          {optionHeader}
          <span style={{ float: 'right' }}>{selectedSize ? selectedSize : ''}</span>
        </div>
        <div className="variants-colors">{renderOptionVariants()}</div>
      </div>
    </div>
  );
}

export default VariantSection;
